import { useState, useEffect } from "react";
import TimeSlot from "./TimeSlot";
import { DateTime } from "luxon";
import uniqid from "uniqid";

const CalendarRow = ({
  timeText,
  reservations,
  timeSlots,
  onOpen,
  setDeletingReservation,
}) => {
  const [reservationArr, setReservationArr] = useState(
    new Array(14).fill(null),
  );
  const [reservableArr, setReservableArr] = useState(new Array(14).fill(true));

  useEffect(() => {
    // int array, with start hour, start minute, end hour, end minute
    const numbers = timeText.match(/\d\d/g).map((str) => Number(str));
    const timeSlotReservations = new Array(14).fill(null);
    let canBeReserved = new Array(14).fill(true);

    // default value for 12~13:00, can't be reserved
    if (numbers[0] === 12) {
      canBeReserved = new Array(14).fill(false);
    }

    const todayMidnight = DateTime.local().startOf("day");

    reservations.forEach((res) => {
      const startTime = DateTime.fromISO(res.startTime);
      const startHour = startTime.hour;
      const startMin = startTime.minute;

      // if time matches, set reserved to true
      if (startHour === numbers[0] && startMin === numbers[1]) {
        const dayDiff = startTime.diff(todayMidnight, ["days"]).days;
        const index = Math.abs(Math.floor(dayDiff));
        // today -> index 0, tomorrow -> index 1, ...
        timeSlotReservations[index] = res;
      }
    });

    setReservationArr(timeSlotReservations);

    // set canBeReserved
    timeSlots.forEach((slot) => {
      const hours = slot.hours;
      const date = DateTime.fromISO(slot.date);

      // if time matches, set reserved to true
      const hour = numbers[0] + Math.round((numbers[1] / 60) * 10) / 10;

      // today -> index 0, tomorrow -> index 1, ...
      const dayDiff = date.diff(todayMidnight, ["days"]).days;
      const index = Math.abs(Math.floor(dayDiff));

      if (hours.includes(hour)) {
        canBeReserved[index] = true;
      } else {
        canBeReserved[index] = false;
      }
    });

    setReservableArr(canBeReserved);
  }, []);

  return (
    <>
      <div className="bg-white py-1 px-2 font-chinese whitespace-nowrap text-custom-gray">
        {timeText ?? "No timeText"}
      </div>
      {reservationArr.map((reservation, index) => (
        <TimeSlot
          key={uniqid()}
          index={index}
          timeText={timeText}
          reservation={reservation}
          reservable={reservableArr[index]}
          onOpen={onOpen}
          setDeletingReservation={setDeletingReservation}
        />
      ))}
    </>
  );
};

export default CalendarRow;
